<template>
  <a class="text-white underline text-base md:text-lg font-bold">
    <slot />
  </a>
</template>
